(function () {
  'use strict';

  function initAboutToggle(root) {
    var list = root.querySelector('[data-pp-about-list]');
    var toggle = root.querySelector('[data-pp-about-toggle]');
    if (!list || !toggle) return;

    toggle.addEventListener('click', function () {
      var expanded = list.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var strong = toggle.querySelector('strong');
      if (strong) {
        strong.textContent = expanded ? '↑ Ver menos ↑' : '↓ Ver más ↓';
      }
    });
  }

  function init() {
    var blocks = document.querySelectorAll('.pp-product-about');
    for (var i = 0; i < blocks.length; i++) {
      initAboutToggle(blocks[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
